package com.solevo.dist.network.api.transactions

import com.solevo.dist.application.models.Transaction
import com.solevo.dist.network.infrastructure.utils.DefaultRemoteSourceImplementationException
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

interface TransactionRemoteSource {
    fun getTransactionsLive(): Flow<List<Transaction>> = flow { throw DefaultRemoteSourceImplementationException() }
    fun getTransaction(id: String): Flow<Transaction?> = flow { throw DefaultRemoteSourceImplementationException() }
    fun getTransactionByInvoiceIdLive(invoiceId: String): Flow<Transaction> = flow { throw DefaultRemoteSourceImplementationException() }
}